import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxsModule } from '@ngxs/store';
import { LocaleModule } from '@x/common/locale';
import { MetaModule } from '@x/common/meta';
import { MoneyModule } from '@x/common/money';
import { OperationModule } from '@x/common/operation';
import { ResponsiveModule } from '@x/common/responsive';
import { AddressModule } from '@x/ecommerce-shop/app/core/address/address.module';
import { RoutingModule } from '@x/ecommerce-shop/app/core/routing/routing.module';
import { ShopErrorModule } from '@x/ecommerce-shop/app/core/shop-error/shop-error.module';
import { BannerButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/banner-button/banner-button.module';
import { BrandingModule } from '@x/ecommerce-shop/app/core/shop-ui/components/branding/branding.module';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { HeaderLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/header-layout/header-layout.module';
import { PageLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/page-layout';
import { ShopLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/shop-layout/shop-layout.module';
import { NeedHelpModule } from '@x/ecommerce-shop/app/core/shop-ui/components/need-help/need-help.module';
import { ShopColorModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-color/shop-color.module';
import { ShopHeaderModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-header/shop-header.module';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { SubscriberRequirementService } from '@x/ecommerce-shop/app/subscriber-checkout/services/subscriber-requirement.service';
import { SubscriberState } from '@x/ecommerce-shop/app/subscriber-checkout/state/subscriber.state';
import { SubscriberAgreementComponent } from './components/subscriber-agreements/subscriber-agreement.component';
import { SubscriberAgreementsComponent } from './components/subscriber-agreements/subscriber-agreements.component';
import { SubscriberCheckoutHeaderComponent } from './components/subscriber-checkout-header/subscriber-checkout-header.component';
import { SubscriberCheckoutSummaryComponent } from './components/subscriber-checkout-summary/subscriber-checkout-summary.component';
import { SubscriberSuccessPageComponent } from './components/subscriber-success-page/subscriber-success-page.component';
import { SubscriberCheckoutPageComponent } from './subscriber-checkout-page.component';
import { SubscriberRoutingModule } from './subscriber-routing.module';

@NgModule({
  providers: [SubscriberRequirementService],
  declarations: [
    SubscriberCheckoutPageComponent,
    SubscriberSuccessPageComponent,
    SubscriberCheckoutSummaryComponent,
    SubscriberCheckoutHeaderComponent,
    SubscriberAgreementComponent,
    SubscriberAgreementsComponent,
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([SubscriberState]),
    SubscriberRoutingModule,
    ShopLayoutModule,
    ShopHeaderModule,
    HeaderLayoutModule,
    BrandingModule,
    RoutingModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    FontAwesomeModule,
    PageLayoutModule,
    AddressModule,
    MatExpansionModule,
    IconUiModule,
    BannerButtonModule,
    MoneyModule,
    UtilsModule,
    MatTooltipModule,
    MetaModule,
    NeedHelpModule,
    ResponsiveModule,
    ShopColorModule,
    OperationModule,
    ShopErrorModule,
    LocaleModule,
  ],
})
export class SubscriberModule {}
